<template>
  <div class="t-calendar-header" :class="{'t-calendar_small__header': mobileCalendar}">
    <template v-if="!(type.value.value !== 1 && mobileState)">
      <button class="t-calendar_small__arrow" @click.prevent="PrevMonth()" v-if="mobileCalendar">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.6001 4.00078H12.4001M1.6001 4.00078L5.2001 1.30078M1.6001 4.00078L5.2001 6.70078" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h2>{{ date_active_text }}</h2>
      <button class="t-calendar_small__arrow" @click.prevent="NextMonth()" v-if="mobileCalendar">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.3999 4.00078H1.5999M12.3999 4.00078L8.7999 1.30078M12.3999 4.00078L8.7999 6.70078" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </template>
    <template v-else>
      <button class="t-calendar_small__arrow" @click.prevent="PrevDay()">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.6001 4.00078H12.4001M1.6001 4.00078L5.2001 1.30078M1.6001 4.00078L5.2001 6.70078" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h2>{{ day_active_text }}</h2>
      <button class="t-calendar_small__arrow" @click.prevent="NextDay()">
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.3999 4.00078H1.5999M12.3999 4.00078L8.7999 1.30078M12.3999 4.00078L8.7999 6.70078" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </template>


    <div v-if="!mobileCalendar" class="t-calendar-header__right">
      <div class="t-calendar__arrow t-calendar-arrow">
        <button class="t-calendar-arrow__prev" @click.prevent="PrevMonth()" v-if="$route.name !== 'courses_create' || date_active > new Date()">
          <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4H13M1 4L5 1M1 4L5 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="t-calendar-arrow__next" @click.prevent="NextMonth()">
          <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 4H1M13 4L9 1M13 4L9 7" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <button class="t-btn t-btn_white" @click.prevent="GoToday()"><span>{{ calendarText.today }}</span></button>
      <div class="t-input">
        <v-select :value="type.value"
                  :options="type.options"
                  :searchable="false"
                  :filterable="false" @input="SetType($event)"></v-select>
      </div>
      <div v-if="$route.name === 'courses_info' && course.type === 3" class="t-input">
        <v-select
                  :value="filter.value"
                  :options="options"
                  :placeholder="calendarText.noStreams"
                  :searchable="false"
                  :disabled="disabled"
                  :filterable="false" @input="SetFilter($event)"></v-select>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters(['mobileState', 'mobileCalendar']),
            ...mapGetters('calendar', ['date_active', 'date_active_text', 'day_active_text', 'type', 'filter', 'calendarText']),
            ...mapGetters('coursesList', ['course', 'streams']),
            options(){
                let opt = [];
                for(let i = 0; i < this.streams.length; i++){
                    opt.push({value: i , label: this.streams[i].id + ' ' + this.calendarText.stream})
                }
                this.SetFilter(opt[0]);
                return opt
            },
            disabled(){
                let disabled = true;

                for(let i = 1; i <= this.streams.length; i++){
                    if (this.calendarText.stream) {
                        disabled = false;
                    }
                }

                return disabled;
            }
        },
        methods: {
            ...mapActions('calendar', ['GoToday', 'PrevMonth', 'NextMonth', 'PrevDay', 'NextDay', 'SetType', 'SetFilter']),
        },
    }
</script>

<style lang="sass">
.t-calendar-header
  display: flex
  align-items: center
  justify-content: space-between
  margin-bottom: 16px
  border-radius: 16px
  position: sticky
  top: 95px
  z-index: 14
  background: #fff
  @media (max-width: 769px)
    top: 0
  h2
    font-size: 22px
    margin: 0
    color: $blue
  &__right
    display: flex
    align-items: center
  .t-input
    margin: 0 0 0 16px
    &:last-child
      width: 223px
      flex: none
    &:nth-last-child(2)
      width: 136px
      flex: none
  .t-input .v-select.disabled
    .dropdown-toggle, .t-input .v-select.disabled .dropdown-toggle input
      background: #e9f1f5
      height: 40px
    .selected-tag
      padding: 0 40px 0 16px
      line-height: 40px
      color: transparent
      &:before
        content: 'Нет потоков'
        color: #666
    .open-indicator
      cursor: not-allowed
      opacity: 0.4
      background-color: transparent

.t-calendar_small__arrow
  width: 36px
  height: 36px
  display: flex
  align-items: center
  justify-content: center
  background: transparent
  border: none
  cursor: pointer
  outline: none
.t-calendar_small__header
  h2
    color: $black
    font-size: 16px
    font-weight: normal
</style>



// WEBPACK FOOTER //
// src/vue_components/Calendar/CalendarHeader.vue